import { createContext, useContext } from 'react';

const CardContext = createContext();

export const CardContextProvider = CardContext.Provider;
export const useCardContext = () => useContext(CardContext);

export default CardContext;
